<template>
  <div class="scroll-wrapper">
    <div
      class="scroll-block"
      :class="{'scroll-block--top': state.top, 'scroll-block--bottom': state.bottom}"
      ref="el"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, reactive, ref } from 'vue';

const state = reactive({
  top: false,
  bottom: false,
});

const el = ref<HTMLElement | null>(null);

function handlePrimaryListFade() {
  if (!el.value) {
    return;
  }

  state.top = el.value.scrollTop > 10;
  state.bottom = el.value.scrollTop + el.value.clientHeight < el.value.scrollHeight - 30;
}

onMounted(() => {
  el.value?.addEventListener('scroll', handlePrimaryListFade);
});
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.scroll-wrapper {
  position: relative;
  overflow: hidden;
}

.scroll-block {
  overflow: auto;
  max-height: 100%;
  -webkit-overflow-scrolling: touch;

  &::before, &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 32px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 250ms ease;
    z-index: 10;

    @media screen and (max-width: $screen-lg-min) {
      height: 26px;
    }
  }

  &::before {
    top: 0;
    background: linear-gradient(180deg, #ffffff 30%, rgba(255, 255, 255, 0) 100%);
  }

  &::after {
    bottom: 0;
    background: linear-gradient(0deg, #ffffff 30%, rgba(255, 255, 255, 0) 100%);
  }

  &--top::before {
    opacity: 1;
  }

  &--bottom::after {
    opacity: 1;
  }
}
</style>
